import React, { useContext } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Context as ConfigContext } from '../Config';
import usePageClassName from '../hooks/usePageClassName';
import useFetchCategoryPage from '../hooks/useCategoryPageData';
import useTranslation from '../hooks/useTranslation';
import { CategoryContext } from '../contexts';
import CategorySchema from '../toolkit/CategorySchema';
import WithTitle from '../toolkit/WithTitle';
import ErrorPage from './error';
import Error404Page from './error404';
import Error401Page from './error401';

type Props = RouteComponentProps<{
  categoryId: string;
}>;

const CategoryPage: React.FC<Props> = ({ match }) => {
  const { t } = useTranslation();
  usePageClassName('category-page');

  const { categoryId } = match.params;
  const categoryMatch = categoryId.match(/^\d+/);
  let _categoryId = categoryMatch ? categoryMatch[0] : '';
  const { data, fetchingStatus } = useFetchCategoryPage(_categoryId);
  const { pages, pageLoadingIndicator: Loader } = useContext(ConfigContext);

  if (
    fetchingStatus === 'is-fetching' ||
    fetchingStatus === 'not-started'
    // || fetchingStatus === 'NotAllowedError'
  )
    return <Loader />;
  if (fetchingStatus === 'NotFound') return <Error404Page />;
  if (fetchingStatus === 'LoginRequired') return <Error401Page />;
  if (fetchingStatus !== 'has-fetched' || !data || !data.category)
    return <ErrorPage />;

  const category = data.category;
  const title = t('pageTitles.category', '{{category.title}}', { category });
  const Page = pages.category.component;

  return (
    <CategoryContext.Provider value={category}>
      <>
        <CategorySchema key={categoryId} />
        <WithTitle title={title}>
          <Page />
        </WithTitle>
      </>
    </CategoryContext.Provider>
  );
};
CategoryPage.displayName = 'CategoryPage';

export default CategoryPage;
